import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { TirPmModal } from "tir-components";
import { EditQueueModalWrapper, EditQueueModalMain, EditQueueModalEmployees } from "./components";
import { EditQueueEnum } from "./enums";
import { computed, PropType, ref } from "vue";
import { QueueTasksModel } from "../sidebar/models";
import { TaskParametersForm, TaskParameterTypeEnum } from "@/components";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'edit-queue-modal',
  props: {
  /**Id редактируемой очереди */
  queue: { type: Object as PropType<QueueTasksModel> },
},
  emits: ["close", "onSave"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Текущий таб */
const currentTab = ref(EditQueueEnum.Statuses);
/**Режим импорта шаблонов */
const importMode = ref(false);
/**Компонент формы для настройки параметров */
const $taskParametersForm = ref<InstanceType<typeof TaskParametersForm>>();
const $editQueueModalEmployees = ref<InstanceType<typeof EditQueueModalEmployees>>();

const modalTitle = computed(() => {
  if (importMode.value) {
    return `Импорт ${compareTab(EditQueueEnum.Statuses) ? "статусов" : "приоритетов"} в очередь "${props.queue?.Name}"`;
  } else {
    return props.queue?.Name || "";
  }
});

/**Проверка совпадения таба */
const compareTab = (type: EditQueueEnum) => type == currentTab.value;

/**Закрыть окно */
const close = () => {
  if ($editQueueModalEmployees.value?.haveChanges) {
    $editQueueModalEmployees.value?.openLeaveConfirmation(() => {
      emit("close");
    });
    return;
  }
  if ($taskParametersForm.value?.haveChanges) {
    $taskParametersForm.value?.openLeaveConfirmation(() => {
      emit("close");
    });
  } else {
    emit("close");
  }
};
/**Установка значения importMode  */
const setImportMode = (isImport: boolean) => {
  importMode.value = isImport;
};
/**Отмена импорт режима, при нажатии кнопки "Назад" */
const onBackStep = () => {
  $taskParametersForm.value?.setImportForm(false);
};
/**Обновление текущего таба */
const onUpdateTab = (tab: EditQueueEnum) => {
  if (tab == currentTab.value) return;
  if ($editQueueModalEmployees.value?.haveChanges) {
    $editQueueModalEmployees.value?.openLeaveConfirmation(() => {
      currentTab.value = tab;
    });
    return;
  }
  if ($taskParametersForm.value?.haveChanges) {
    $taskParametersForm.value?.openLeaveConfirmation(() => {
      currentTab.value = tab;
    });
  } else {
    currentTab.value = tab;
  }
};
function saveUsersAccess() {
  emit("onSave");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TirPmModal), {
      classes: "edit-queue-modal",
      "is-close-overlay": "",
      "is-with-step": "",
      numberStep: 1,
      title: modalTitle.value,
      "is-visible": !!__props.queue,
      "is-with-back": importMode.value,
      onClose: close,
      onBackStep: onBackStep
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(EditQueueModalWrapper), {
          tab: currentTab.value,
          "onUpdate:tab": onUpdateTab
        }, {
          default: _withCtx(() => [
            (compareTab(_unref(EditQueueEnum).Main))
              ? (_openBlock(), _createBlock(_unref(EditQueueModalMain), {
                  key: 0,
                  queue: __props.queue
                }, null, 8, ["queue"]))
              : (compareTab(_unref(EditQueueEnum).Employees))
                ? (_openBlock(), _createBlock(_unref(EditQueueModalEmployees), {
                    key: 1,
                    queue: __props.queue,
                    ref_key: "$editQueueModalEmployees",
                    ref: $editQueueModalEmployees,
                    onOnSave: saveUsersAccess,
                    onOnClose: close
                  }, null, 8, ["queue"]))
                : (compareTab(_unref(EditQueueEnum).Statuses))
                  ? (_openBlock(), _createBlock(_unref(TaskParametersForm), {
                      key: 2,
                      ref_key: "$taskParametersForm",
                      ref: $taskParametersForm,
                      type: _unref(TaskParameterTypeEnum).Status,
                      "entity-id": __props.queue.Id,
                      onImport: setImportMode
                    }, null, 8, ["type", "entity-id"]))
                  : (compareTab(_unref(EditQueueEnum).Priorities))
                    ? (_openBlock(), _createBlock(_unref(TaskParametersForm), {
                        key: 3,
                        ref_key: "$taskParametersForm",
                        ref: $taskParametersForm,
                        type: _unref(TaskParameterTypeEnum).Priority,
                        "entity-id": __props.queue.Id,
                        onImport: setImportMode
                      }, null, 8, ["type", "entity-id"]))
                    : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["tab"])
      ]),
      _: 1
    }, 8, ["title", "is-visible", "is-with-back"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }))
  ], 64))
}
}

})